module.exports = __webpack_public_path__ + "static/media/save.5d0b955e.svg";